import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=25a85af5"
import script from "./Sensor.vue?vue&type=script&lang=ts"
export * from "./Sensor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports